import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import type { FC } from "react";
import Tasks from "./Tasks";
import type { TaskEntityType } from "./tasksApi";

interface Props {
  readonly entityType: TaskEntityType;
  readonly entityId: string;
  readonly customerId: string;
}

const ExpandableTasks: FC<Props> = ({ entityType, entityId, customerId }) => {
  return (
    <Accordion defaultExpanded slotProps={{ transition: { unmountOnExit: true, mountOnEnter: true } }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Zadania</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Tasks entityType={entityType} entityId={entityId} customerId={customerId} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ExpandableTasks;
